<script>
	let active = false;
	$: currentCS =
		window.matchMedia &&
		window.matchMedia(`(prefers-color-scheme: dark)`).matches
			? "Light"
			: "Dark";

	function toggleCS() {
		document.documentElement.toggleAttribute(currentCS);
		currentCS = currentCS === "Dark" ? "Light" : "Dark";
		document.documentElement.removeAttribute(currentCS);
		active = !active;
	}
</script>

<div class="footer-wrapper">
	<footer class="container">
		<ul class="list-none">
			<li><a href="https://github.com/mulsun/">github</a></li>
			<li>
				<a href="https://stackoverflow.com/users/3479395/">stackoverflow</a>
			</li>
			<li><a href="https://codepen.io/mulsun">codepen</a></li>
			<li><a href="https://linkedin.com/in/mulsun">linkedin</a></li>
		</ul>
		<br />
		<ul class="list-none">
			<li><a href="http://twitter.com/mulsun">twitter</a></li>
			<li><a href="http://instagram.com/mulsun">instagram</a></li>
			<li><a href="https://soundcloud.com/mulsun">soundcloud</a></li>
			<li><a href="https://open.spotify.com/user/11102680203">spotify</a></li>
		</ul>
	</footer>
	<div class="footer-last">
		<button on:click={toggleCS} aria-pressed={active}>
			{currentCS === "Dark" ? "🌑" : "🌕"}
			<span class="sr-only"
				>Toggle {currentCS === "Dark" ? "Dark" : "Light"} Theme</span
			>
		</button>
		// Made with
		<a target="blank" href="https://svelte.dev/">Svelte</a>.
	</div>
</div>

<style>
	footer {
		line-height: 1.75;
	}

	@media (min-width: 576px) {
		footer ul {
			display: inline-flex;
			flex-wrap: wrap;
		}
	}

	footer ul li a {
		padding: 3px;
	}

	.footer-last {
		font-size: 0.75rem;
	}

	.footer-last:not(:hover):not(:focus) {
		opacity: 0.5;
	}
</style>
